import { useMenu } from 'context/MenuContext';
import styles from './styles.module.scss';

function OptionalLinks() : JSX.Element {
  const { customConfig } = useMenu();
  const profileLinks = customConfig.profileLinks;

  if(!profileLinks)
    return <></>;

  return (
    <div className={styles['biobar-optional-links']}>
      <p>{profileLinks.title}</p>
      {profileLinks.links.map((x, i) => <a href={x.url} key={i}>{x.title}</a>)}
    </div>
  );
}

export default OptionalLinks;